
/**
 * Map your Stripe Price IDs here (live or test).
 * Replace the placeholders with your real price IDs from the Stripe Dashboard.
 */
export const PRICES = {
  strategyCallUSD: import.meta.env.VITE_PRICE_STRATEGY_CALL_USD || "price_xxx_strategy_call",
  seoAuditUSD: import.meta.env.VITE_PRICE_SEO_AUDIT_USD || "price_xxx_seo_audit",
  growthRetainerMonthlyUSD: import.meta.env.VITE_PRICE_GROWTH_RETAINER_MONTHLY_USD || "price_xxx_retainer_monthly",
};

export type PriceKey = keyof typeof PRICES;

export function getPriceId(key: PriceKey) {
  const id = PRICES[key];
  if (!id || id.startsWith("price_xxx")) {
    console.warn(`Missing Stripe price ID for ${key}. Set VITE_* env vars in Netlify.`);
  }
  return id;
}
